import React, { useEffect, useState } from 'react';

import Typography from '../../../../components/Typography/Typography';
import { MessageBoxContentStyled, MessageBoxStyled } from '../BannerMessages/BannerMessages.styled';
import useBannerMessages from './hooks/useBannerMessages';
import { BannerMessageI } from 'declarations/interfaces/notifications';

type LinkifyPropsT = {
  messageText: string;
  linkClass?: string;
  linkStyle?: React.CSSProperties;
};

const Linkify: React.FC<LinkifyPropsT> = ({ messageText, linkClass, linkStyle }) => {
  const isUrl = (word: string) => {
    const urlPattern = // eslint-disable-next-line
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm.test(
        word
      );
    return urlPattern;
  };

  const addMarkup = (word: string, index: number) => {
    const space = index === 0 ? '' : ' ';
    const url = isUrl(word) ? word : null;

    if (url) {
      return (
        <React.Fragment key={index}>
          {space}
          <a href={url} target="_blank" rel="noreferrer" className={linkClass} style={linkStyle}>
            {word}
          </a>
          {space}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment key={index}>
        {space}
        {word}
        {space}
      </React.Fragment>
    );
  };

  const words = messageText.split(' ');
  const formattedWords = words.map((w, i) => addMarkup(w, i));

  return <span>{formattedWords}</span>;
};

const BannerMessages = () => {
  const [reRender, setReRender] = useState(false);
  /**
   * Hooks
   */
  const { bannerMessages, bannerMessageColor } = useBannerMessages();

  useEffect(() => {
    if (bannerMessages !== null) {
      bannerMessages?.forEach(message => {
        const updatedDateTime = message.updatedDateTime?.toString() ?? new Date(0).toISOString();
        const previousTime = localStorage.getItem(message.id) ?? new Date(0).toISOString();

        if (Date.parse(previousTime) === Date.parse(updatedDateTime)) {
          message.isNew = false;
        } else {
          message.isNew = true;
        }

        localStorage.setItem(message.id, updatedDateTime);
      });
    }

    setReRender(!reRender); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerMessages]);
  if (!bannerMessages || bannerMessages.length === 0) {
    return null;
  }

  return (
    <MessageBoxStyled>
      <MessageBoxContentStyled>
        {bannerMessages?.map((bannerMessage: BannerMessageI) => (
          <Typography
            size="md"
            color={bannerMessageColor(bannerMessage.type)}
            key={bannerMessage.id}
            style={{ backgroundColor: bannerMessage.isNew ? 'yellow' : 'white' }}
          >
            <Linkify
              messageText={bannerMessage.message ?? ''}
              linkClass="custom-link"
              linkStyle={{ color: 'blue', textDecoration: 'underline' }}
            />
          </Typography>
        ))}
      </MessageBoxContentStyled>
    </MessageBoxStyled>
  );
};

export default BannerMessages;
